<template>
  <svg class="heart-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4936 8.22088C21.3729 14.4258 14.3069 21.7906 6.02097 19.3464C1.81249 18.105 0.717187 15.3539 0.959984 13.344C1.2838 10.6634 4.01398 9.8147 5.14197 8.7561C6.78799 7.21136 3.66017 3.70202 8.28833 0.883365C12.0193 -1.38891 17.592 1.9425 19.4936 8.22088Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'heart-icon',
  props: {
    outlined: Boolean
  }
}
</script>

<style lang="scss" scoped>
</style>
